import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

/**
 * Fetches company data by ticker and passes it to the setter.
 * @param {string} ticker - The company ticker.
 * @param {function} setSelectedCompany - State setter to update selected company.
 */
export default async function selectCompanyByTicker(ticker, setSelectedCompany) {
  try {
    if (!ticker) return;

    const snapshot = await getDocs(collection(db, "Companies"));
    const company = snapshot.docs
      .map(doc => doc.data())
      .find(c => c.companyTicker === ticker);

    if (company) {
      setSelectedCompany(company);
    } else {
      console.warn(`Company with ticker "${ticker}" not found`);
    }
  } catch (err) {
    console.error("Error selecting company by ticker:", err);
  }
}
